import React, { FC } from 'react';
import { useParams } from 'react-router-dom';

import { useGetCombinedGroupWebhookListQuery } from 'api';
import { useNotify } from 'hooks';
import { Loaders } from 'components';

import EditGroup from './Edit';
import {
  GroupDataProvider,
  GroupModeratorsProvider,
  GroupSourcesProvider,
  WorkvivoWebhookProvider,
} from '../providers';

const EditGroupLoader: FC = () => {
  const { group_id } = useParams<{ group_id: string }>();
  const notify = useNotify();

  const { data, isLoading } = useGetCombinedGroupWebhookListQuery(
    { id: group_id },
    {
      onError: notify.queryError,
    }
  );

  if (isLoading) {
    return <Loaders.Standard />;
  }

  return (
    <GroupDataProvider>
      <GroupModeratorsProvider>
        <GroupSourcesProvider>
          <WorkvivoWebhookProvider groupWebhookList={data?.getGroupWebhookList || null}>
            <EditGroup group={data?.getGroup || null} />
          </WorkvivoWebhookProvider>
        </GroupSourcesProvider>
      </GroupModeratorsProvider>
    </GroupDataProvider>
  );
};

export default EditGroupLoader;
